// 子应用监听消息统一方法
const addListenerFnStr = `
($router, $store, Cookies, setToken) => {
  const treeToArray = (tree) => {
    // tree是要传递的树形结构数组
    const arr = []
    const expanded = datas => {
      if (datas && datas.length > 0) {
        datas.forEach(e => {
          arr.push(e)
          expanded(e.children)
        })
      }
    }
    expanded(tree)
    return arr
  }
  if (localStorage.getItem("inMicroAppStatus") === "in") {
    window.microApp.removeDataListener()
    window.microApp.removeGlobalDataListener()
    // 单应用通信监听
    window.microApp.addDataListener(data => {
      window.isMatchRouterInfo = data.matchRouterInfo||{}
      switch (data.type) {
        // type为类型，值router为跳转类型
        case "router":
          //先跳一下大盘页面，解决缓存问题
          $router.replace({ name: "Dashboard", query: { dontJump: true } })
          //存储当前路由信息
          window.$matchRouterInfo = data.matchRouterInfo||{}
          const menuList = treeToArray($router.options.routes)
          //解决关闭后，缓存数组没有存入的问题
          setTimeout(()=>{
             $router.push({ path: data.data })
          },100)
          setTimeout(()=>{
            menuList.forEach(item=>{
              if(item.fullPath===data.data){
                $store.dispatch("tagsView/addCachedView", item)
              }
            })
          },250)
          break
        case "store":
          if(data.data.fnType==="commit"){
            $store.commit(data.data.nameSpace,data.data.fnData)
          }
          if(data.data.fnType==="dispatch"){
            $store.dispatch(data.data.nameSpace,data.data.fnData)
          }
          break
        default:
          if(data.matchRouterInfo&&data.matchRouterInfo.pathName){
            setTimeout(()=>{
              $store.dispatch("tagsView/addCachedView", { name: data.matchRouterInfo.pathName, meta: { noCache: false } })
            },500)
          }
      }
    }, true)
    // 全局通信监听
    window.microApp.addGlobalDataListener(info => {
      const { type, data } = info
      switch (type) {
        case "token": // 登陆状态
          Cookies.set("ct_sso", data)
          setToken(data)
          break
        case "sidebarOpened": // 侧边栏展开收起状态
          $store.dispatch("app/changeSidebarStatus", data)
          break
        case "store":
          if(data.fnType==="commit"){
            $store.commit(data.nameSpace,data.fnData)
          }
          if(data.fnType==="dispatch"){
            $store.dispatch(data.nameSpace,data.fnData)
          }
          if(data.fnType==="dispatchArr"){
            data.fnData.forEach( item => {
              $store.dispatch(data.nameSpace,item)
            })
          }
          break
        default:
          console.log("全局监听结果")
          console.log(info)
      }
    }, true)
  }
}`
// 挂载全局
window._globalControl = addListenerFnStr
